import React from 'react'
import Button from '../button/index.js'

const ButtonGroup = ({ 
  isFullWidth = true, 
  list = [], 
  className, 
  hasAriaLabel = false 
}) => {
  if (list?.length < 1 || !list) return;

  return (
    <div className={`flex flex-col gap-small shrink-0 w-full ${isFullWidth ? 'md:w-full' : 'md:w-fit'} items-center ${className || ''}`}>
      {list?.map((data, index) => {
        return (
          <Button
            key={index}
            {...data}
            title={data?.internalLink?.title || data?.text}
            ariaLabel={`${
              hasAriaLabel
                ? `${data?.text}: ${data?.internalLink?.title || ""}`
                : ""
            }`}
          />
        )
      })}
    </div>
  )
}

export default ButtonGroup